module.exports = __webpack_public_path__ + "static/media/featured_img_two.a7551c7a.png";